// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsIndicatorsAddTemplate_heading__YPcVz","buttonLink":"ReportingDetailsIndicatorsAddTemplate_buttonLink__8Bk-T"};